'use client'

import { useRouter, usePathname, useSearchParams } from 'next/navigation'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'

interface ShowArchivedToggleProps {
  showArchived: boolean
}

export function ShowArchivedToggle({ showArchived }: ShowArchivedToggleProps) {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  function handleChange(checked: boolean) {
    const params = new URLSearchParams(searchParams.toString())
    if (checked) {
      params.set('showArchived', 'true')
    } else {
      params.delete('showArchived')
    }
    router.push(`${pathname}?${params.toString()}`)
  }

  return (
    <div className="flex items-center space-x-2">
      <Checkbox
        id="show-archived"
        checked={showArchived}
        onCheckedChange={handleChange}
      />
      <Label htmlFor="show-archived" className="text-sm cursor-pointer">
        Show archived customers
      </Label>
    </div>
  )
}
